import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  Apuracao,
  EventoConsumo,
  FecharCicloFormData,
  ReabrirCicloFormData,
  RejectedInvoice,
  ReprocessarEventosFormData,
} from '../types';
import { apuracaoService } from './services';

export const fetchApuracoes = createAsyncThunk<Apuracao[]>(
  'apuracao/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      return await apuracaoService.fetchAll();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchApuracaoById = createAsyncThunk<Apuracao, string>(
  'apuracao/fetchById',
  async (apuracaoId, { rejectWithValue }) => {
    try {
      return await apuracaoService.fetchById(apuracaoId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchEventoDetalhe = createAsyncThunk<EventoConsumo, string>(
  'apuracao/fetchEventoDetalhe',
  async (eventoId, { rejectWithValue }) => {
    try {
      return await apuracaoService.fetchEventoDetalhe(eventoId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchRejeitadosDoCiclo = createAsyncThunk<RejectedInvoice[], string>(
  'apuracao/fetchRejeitadosDoCiclo',
  async (cycleId, { rejectWithValue }) => {
    try {
      return await apuracaoService.fetchRejeitadosDoCiclo(cycleId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const reemitirFaturaRejeitada = createAsyncThunk<
  RejectedInvoice[],
  { invoiceId: string; cycleId: string }
>('apuracao/reemitirFaturaRejeitada', async ({ invoiceId, cycleId }, { rejectWithValue }) => {
  try {
    await apuracaoService.reemitirFaturaRejeitada(invoiceId);
    return await apuracaoService.fetchRejeitadosDoCiclo(cycleId);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const fecharCicloApuracao = createAsyncThunk<Apuracao, FecharCicloFormData>(
  'apuracao/fecharCiclo',
  async (data, { rejectWithValue }) => {
    try {
      return await apuracaoService.fecharCiclo(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const reabrirCicloApuracao = createAsyncThunk<Apuracao, ReabrirCicloFormData>(
  'apuracao/reabrirCiclo',
  async (data, { rejectWithValue }) => {
    try {
      return await apuracaoService.reabrirCiclo(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const marcarApuracaoFaturada = createAsyncThunk<
  Apuracao,
  { apuracaoId: string; faturaNumero: string }
>('apuracao/marcarFaturada', async (data, { rejectWithValue }) => {
  try {
    return await apuracaoService.marcarApuracaoFaturada(data.apuracaoId, data.faturaNumero);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const reprocessarEventos = createAsyncThunk<EventoConsumo[], ReprocessarEventosFormData>(
  'apuracao/reprocessarEventos',
  async (data, { rejectWithValue }) => {
    try {
      return await apuracaoService.reprocessarEventos(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
